import * as CONST from '../ActionTypes';

const initialState = {
  authLoading: true,
  isLoggedIn: false,
  errorMessage: '',
  // ログインユーザーの情報
  id: null,
  email: '',
  name: '',
  accessToken: '',
  refreshToken: '',
  // パスワード更新用
  isSuccess: false,
  isFailure: false,
  updateErrorMessage: '',
};

function auth(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // ログイン
    // -----------------
    case CONST.LOGIN_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isLoggedIn: true,
          errorMessage: '',
          id: action.payload.employee.id,
          email: action.payload.employee.email,
          name: action.payload.employee.name,
          accessToken: action.payload.access_token,
          refreshToken: action.payload.refresh_token,
        },
      );
    case CONST.LOGIN_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isLoggedIn: false,
          errorMessage: 'Eメールかパスワードが正しくありません',
          id: null,
          email: '',
          name: '',
          accessToken: '',
          refreshToken: '',
        },
      );
    // -----------------
    // リフレッシュトークンでログイン
    // -----------------
    case CONST.REFRESH_TOKEN_LOGIN_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isLoggedIn: true,
          errorMessage: '',
          id: action.payload.employee.id,
          email: action.payload.employee.email,
          name: action.payload.employee.name,
          accessToken: action.payload.access_token,
          refreshToken: action.payload.refresh_token,
          authLoading: false,
        },
      );
    case CONST.REFRESH_TOKEN_LOGIN_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isLoggedIn: false,
          errorMessage: '',
          id: null,
          email: '',
          name: '',
          accessToken: '',
          refreshToken: '',
          authLoading: false,
        },
      );
    // -----------------
    // パスワード更新
    // -----------------
    case CONST.UPDATE_PASSWORD_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.UPDATE_PASSWORD_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          updateErrorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_UPDATE_PASSWORD_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          updateErrorMessage: '',
        },
      );
    // -----------------
    // ログアウト
    // -----------------
    case CONST.LOGOUT:
      return Object.assign(
        {},
        state,
        {
          authLoading: false,
          isLoggedIn: false,
          errorMessage: '',
          id: null,
          email: '',
          name: '',
          accessToken: '',
          refreshToken: '',
        },
      );
    default:
      return state;
  }
}

export default auth;
